import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaSignInAlt, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/logoelite.jpeg";
import "./Home.css";
import science from "../assets/Science.jpg";
import maths from "../assets/Maths.jpg";
import reasoning from "../assets/Reasoning.jpg";

const PrimeProgramme = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const go = (path) => { setMenuOpen(false); navigate(path); };

  const pillars = [
    {
      id: "science",
      title: "Science",
      desc: "Concept-driven lessons for Physics, Chemistry and Biology with demonstrations, worked examples and progressive practice sets to build robust understanding.",
      img: science,
      accent: "#283593"
    },
    {
      id: "maths",
      title: "Mathematics",
      desc: "Topic-wise theory, solved examples and multi-level exercises focused on reasoning and application — designed to strengthen foundations and accelerate problem solving.",
      img: maths,
      accent: "#6A1B9A"
    },
    {
      id: "reasoning",
      title: "Reasoning",
      desc: "Logical reasoning modules and practice to sharpen analytical thinking — ideal for competitive assessments and overall cognitive skills development.",
      img: reasoning,
      accent: "#0D47A1"
    }
  ];

  return (
    <div className="features-page" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <header className="header" style={{ position: "sticky", top: 0, zIndex: 90 }}>
        <div className="logo-container">
          <img src={logo} alt="Elite Academy Logo" className="logo" />
          <span className="logo-text">Elite Academy</span>
        </div>

        <button
          className="menu-icon"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(s => !s)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="nav-btn-link" onClick={() => go("/")}>HOME</button>
          <button className="nav-btn-link" onClick={() => go("/about")}>ABOUT US</button>
          <button className="nav-btn-link" onClick={() => go("/features")}>FEATURES</button>
          <button className="nav-btn-link" onClick={() => go("/contact")}>CONTACT US</button>
        </nav>

        <div className="header-right">
          <a className="phone-btn" href="tel:+917330643345"><FaPhone /> +91 7330643345</a>
          <button className="login-btn" onClick={() => go("/login")}><FaSignInAlt /> Login</button>
        </div>
      </header>

      <section
        className="features-hero"
        style={{
          background: "linear-gradient(135deg, rgba(81,45,168,0.92), rgba(24,118,210,0.86)), url('https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?auto=format&fit=crop&w=1600&q=60') center/cover no-repeat",
          color: "#fff",
          padding: "60px 20px",
          textAlign: "center"
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <h1 style={{ fontSize: 40, marginBottom: 12 }}>Prime Programme</h1>
          <p style={{ maxWidth: 980, margin: "0 auto", background: "rgba(255,255,255,0.06)", padding: 16, borderRadius: 10, lineHeight: 1.6 }}>
            A curriculum-aligned, deep learning track focused on mastery. The Prime Programme covers Science, Mathematics and Reasoning with rich content, practice and assessment.
          </p>
        </div>
      </section>

      <main style={{ flex: 1, padding: "40px 20px", background: "#f8fafc" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24 }}>
          {pillars.map(p => (
            <article key={p.id} style={{ background: "#fff", borderRadius: 12, overflow: "hidden", boxShadow: "0 10px 30px rgba(16,24,40,0.06)", display: "flex", flexDirection: "column" }}>
              <div style={{ height: 160, overflow: "hidden" }}>
                <img src={p.img} alt={p.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
              </div>

              <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 12, flex: 1 }}>
                <h2 style={{ margin: 0, color: p.accent, fontSize: 20, fontWeight: 800 }}>{p.title}</h2>
                <p style={{ margin: 0, color: "#374151", lineHeight: 1.6, flex: 1 }}>{p.desc}</p>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
                  <span style={{ background: `${p.accent}22`, color: p.accent, padding: "6px 10px", borderRadius: 18, fontWeight: 700, fontSize: 13 }}>{p.title}</span>
                  
                </div>
              </div>
            </article>
          ))}
        </div>

        <div style={{ maxWidth: 1200, margin: "28px auto 0", textAlign: "center" }}>
          <button onClick={() => go("/")} style={{ padding: "12px 20px", borderRadius: 10, background: "#283593", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer" }}>
            Back to Home
          </button>
        </div>
      </main>

      <footer className="footer" style={{ padding: 28, textAlign: "center", background: "#f7f7f7", borderTop: "1px solid #eef2f7" }}>
        <p style={{ margin: 0, color: "#6b7280" }}>&copy; {new Date().getFullYear()} Elite Academy. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default PrimeProgramme;